const convertTypeDepositWithdraw = (type, color) => {
  let response = type;
  switch (type) {
    case "DEPOSIT":
      response = "ອອມ";
      if (color) response = <span style={{ color: "#0DCD5A" }}>ອອມ</span>;
      break;
    case "WITHDRAW":
      response = "ຖອນ";
      if (color) response = <span style={{ color: "#FF0000" }}>ຖອນ</span>;
      break;
    case "DIVIDEND":
      response = "ປັນຜົນ";
      if (color) response = <span style={{ color: "#0DCD5A" }}>ປັນຜົນ</span>;
      break;

    default:
    // code block
  }
  return response;
};

export default convertTypeDepositWithdraw;
